import React from 'react';
import { Check } from 'lucide-react';
import Button from '../../common/Button';
import type { SupportPlan } from '../../../types/support';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';

interface SupportTierCardProps extends SupportPlan {
  featured?: boolean;
}

const SupportTierCard: React.FC<SupportTierCardProps> = ({ 
  name,
  description,
  features,
  featured = false
}) => {
  const { t } = useTranslatedContent('saas');

  return (
    <div 
      className={`rounded-2xl p-8 ${
        featured 
          ? 'bg-blue-600 text-white ring-4 ring-blue-600 ring-opacity-50' 
          : 'bg-white text-gray-900 shadow-xl'
      }`}
    >
      <h3 className={`text-2xl font-semibold ${featured ? 'text-white' : 'text-gray-900'}`}>
        {name}
      </h3>
      
      <p className={`mt-4 text-sm ${featured ? 'text-blue-100' : 'text-gray-500'}`}>
        {description}
      </p>

      <ul className="mt-8 space-y-4">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <Check className={`h-5 w-5 ${featured ? 'text-blue-200' : 'text-blue-600'} mr-2`} />
            <span className={featured ? 'text-blue-100' : 'text-gray-600'}>
              {feature}
            </span>
          </li>
        ))}
      </ul>

      <Button
        variant={featured ? 'secondary' : 'primary'}
        className={`mt-8 w-full justify-center ${
          featured 
            ? 'bg-white text-blue-600 hover:bg-blue-50' 
            : ''
        }`}
        onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
      >
        {t('buttons.getQuote')}
      </Button>
    </div>
  );
};

export default SupportTierCard;